// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OggcM4 {
  border: none;
  padding: 0;
  position: fixed;
  top: 0;
  right: 0;
  left: auto;
  width: 400px;
  height: 100vh;
  min-height: 100vh;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s) 0 0 var(--radius-s);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  cursor: default;
  z-index: 1300;
}

.d1CumT {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.m1GoPV {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  position: relative;
}

.OggcM4:focus {
  outline: none;
}

.OggcM4::backdrop {
  background: var(--neutral-dark-opacity-50);
}

.ZqPe64 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: transparent;
  border: none;
  cursor: default;
}

.OggcM4[open] {
  margin: 0;
  height: 100vh;
  min-height: 100vh;
}

.IByjYM {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1);
  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);
  flex-shrink: 0;
}

.S2oyYI {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.kd5_Qq {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.sw_qSW {
  width: 16px;
  height: 16px;
}

.KCTCMo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  background: var(--surface-neutral-white);
  padding: var(--spacing-3);
  padding-bottom: 380px;
  gap: var(--spacing-3);
  min-height: 0;
}

.Mu4P6X {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-1);
}

.K04MrL {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1-5);
  flex-wrap: wrap;
}

.rBGME2 {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--spacing-2);
  align-items: flex-start;
}

.rBGME2 > * {
  flex: 1;
  min-width: 0;
}

.JCUmZG {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1);
  flex-wrap: wrap;
  margin-top: 6px;
}

.zB6OWU {
  padding: var(--spacing-0-5) var(--spacing-1);
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  background: var(--surface-neutral-soft);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  cursor: pointer;
  transition: all 0.2s ease;
  height: 24px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.zB6OWU.YhhOOT {
  background: var(--surface-primary-subtle);
  border: 1px solid var(--surface-primary-medium);
  color: var(--text-primary-medium);
  font-weight: var(--font-weight-semibold);
}

.kToPDS {
  width: 12px;
  height: 12px;
  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)
    contrast(104%);
}

.zB6OWU:hover {
  background: var(--surface-neutral-subtle);
}

.zB6OWU:active {
  background: var(--surface-neutral-medium);
  transform: scale(0.98);
}

.tBdkG1 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: left;
}

.Yyv5b7 {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
  border-top: 1px solid var(--border-neutral-light);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  z-index: 10;
}

.aBUfUS {
  position: relative;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/contabilidade-digital/src/pages/ContabilidadeDigitalDasboard/components/AccountTransactionsFilter/AccountTransactionsFilter.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kDAAkD;EAClD,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;EAC/C,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;kBACgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,iDAAiD;EACjD,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".modal {\n  border: none;\n  padding: 0;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: auto;\n  width: 400px;\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s) 0 0 var(--radius-s);\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  cursor: default;\n  z-index: 1300;\n}\n\n.modalContentWrapper {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100%;\n  overflow-y: auto;\n  position: relative;\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal::backdrop {\n  background: var(--neutral-dark-opacity-50);\n}\n\n.backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: transparent;\n  border: none;\n  cursor: default;\n}\n\n.modal[open] {\n  margin: 0;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);\n  flex-shrink: 0;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.chevronLeft {\n  width: 16px;\n  height: 16px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  width: 100%;\n  background: var(--surface-neutral-white);\n  padding: var(--spacing-3);\n  padding-bottom: 380px;\n  gap: var(--spacing-3);\n  min-height: 0;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1-5);\n  flex-wrap: wrap;\n}\n\n.dateRow {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: var(--spacing-2);\n  align-items: flex-start;\n}\n\n.dateRow > * {\n  flex: 1;\n  min-width: 0;\n}\n\n.quickPeriodRow {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1);\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n.quickPeriodButton {\n  padding: var(--spacing-0-5) var(--spacing-1);\n  border-radius: var(--radius-pill);\n  border: 1px solid transparent;\n  background: var(--surface-neutral-soft);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  height: 24px;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.quickPeriodButton.selected {\n  background: var(--surface-primary-subtle);\n  border: 1px solid var(--surface-primary-medium);\n  color: var(--text-primary-medium);\n  font-weight: var(--font-weight-semibold);\n}\n\n.closeIcon {\n  width: 12px;\n  height: 12px;\n  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)\n    contrast(104%);\n}\n\n.quickPeriodButton:hover {\n  background: var(--surface-neutral-subtle);\n}\n\n.quickPeriodButton:active {\n  background: var(--surface-neutral-medium);\n  transform: scale(0.98);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n  border-top: 1px solid var(--border-neutral-light);\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);\n  z-index: 10;\n}\n\n.button {\n  position: relative;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `OggcM4`,
	"modalContentWrapper": `d1CumT`,
	"modalContent": `m1GoPV`,
	"backdrop": `ZqPe64`,
	"header": `IByjYM`,
	"title": `S2oyYI`,
	"closeButton": `kd5_Qq`,
	"chevronLeft": `sw_qSW`,
	"body": `KCTCMo`,
	"column": `Mu4P6X`,
	"row": `K04MrL`,
	"dateRow": `rBGME2`,
	"quickPeriodRow": `JCUmZG`,
	"quickPeriodButton": `zB6OWU`,
	"selected": `YhhOOT`,
	"closeIcon": `kToPDS`,
	"label": `tBdkG1`,
	"footer": `Yyv5b7`,
	"button": `aBUfUS`
};
module.exports = ___CSS_LOADER_EXPORT___;
